<template>
  <div
    data-slot="sidebar-inset"
    :class="
      cn(
        'bg-base-100 relative flex w-full min-w-0 flex-1 flex-col',
        props.class,
      )
    "
  >
    <slot />
  </div>
</template>

<script setup lang="ts">
import type { HTMLAttributes } from "vue";
import { cn } from "@/lib/utils";

const props = defineProps<{
  class?: HTMLAttributes["class"];
}>();
</script>
